/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2023-04-05 20:09:14
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2025-01-21 09:39:52
 * FilePath     :\AV-COM-user-backend\src\utils\message.js
 * RevisionHistory:
 */
import {
    Message
} from "element-ui";
let messageInstance = null;
const resetMessage = (options) => {
    if (messageInstance) {
        messageInstance.close();
    }
    messageInstance = Message(options);
};
["error", "success", "info", "warning"].forEach((type) => {
    resetMessage[type] = (options) => {
        if (typeof options === "string") {
            options = {
                message: options,
                duration: 2000,
            };
        }
        options.type = type;
        return resetMessage(options);
    };
});
export const message = resetMessage;